import Vue from 'vue';

// Create global event bus (for non-essential state changes only.)
export const EventBus = new Vue();
